import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import AppCalendar from "../../../components/AppCalendar/AppCalendar";
import FreeTimeToCome from "../../../components/FreeTimeToCome/FreeTimeToCome";
import { freeTimeToCome } from "../../../constants/freeTimeToCome";
import { MAIN_ROUTES } from "../../../routing/main_routes";
import { stepperInfoActions } from "../../../store/slices/stepperInfoSlice";
import { getKyivNow } from "../../../utils/kyivTime";
import styles from './DateTimeOrderPage.module.scss';

const DateTimeOrderPage = ({setCurrentStep}) => {

    const dispatch = useDispatch();
    const {
        selectedDate,
        selectedTime,
        accessToApartment,
        locationAccessToApartment,
        request_datetime,
        comment,
    } = useSelector(state => state.stepperInfo);

    const currentStep = JSON.parse(localStorage.getItem('currentStep'));
    const navigate = useNavigate();

    useEffect(() => {
        if (currentStep !== 4) {
            navigate(MAIN_ROUTES.CREATE_ORDER);
        }
    }, []);

    useEffect(() => {
        //set default values for selectedDate, selectedTime, accessToApartment
        if (!selectedDate && !selectedTime && !accessToApartment && !request_datetime) {
            console.error('set default values')
            dispatch(stepperInfoActions.setSelectedDate(new Date().toISOString()));
            dispatch(stepperInfoActions.setSelectedTime(filteredTime[0] || freeTimeToCome[0]));
            dispatch(stepperInfoActions.setAccessToApartment('Я буду вдома'));
            const combinedDateTime = moment(new Date()).set({
                hour: selectedTime?.split(':')[0],
                minute: selectedTime?.split(':')[1],
            });
            dispatch(stepperInfoActions.setRequestDateTime(combinedDateTime.toISOString()));
        }
    }, [])

    // useEffect(() => {
    //     if (!selectedDate && !selectedTime && !accessToApartment && !request_datetime) {
    //         if ((new Date().getDate() === new Date(selectedDate).getDate()) && (new Date().getMonth() === new Date(selectedDate).getMonth()) && (new Date().getFullYear() === new Date(selectedDate).getFullYear())) {
    //             const currentDate = new Date();
    //             currentDate.setDate(currentDate.getDate() + 1);
    //             dispatch(stepperInfoActions.setSelectedDate(currentDate.toISOString()));
    //             dispatch(stepperInfoActions.setSelectedTime(filteredTime[0] || freeTimeToCome[0]));
    //             const combinedDateTime = moment(currentDate).set({
    //                 hour: selectedTime?.split(':')[0],
    //                 minute: selectedTime?.split(':')[1],
    //             });
    //             dispatch(stepperInfoActions.setRequestDateTime(combinedDateTime.toISOString()));
    //         }
    //     }
    // }, [])

    const filteredTime = freeTimeToCome.filter(time => {
        const currentHour = getKyivNow().getHours();
        const [hour] = time.split(':');
        return parseInt(hour) > currentHour + 2;
    });

    const handleSelectAccessToApartment = (access) => {
        dispatch(stepperInfoActions.setAccessToApartment(access));
    }

    const handleChangeLocationAccessToApartment = (e) => {
        const location = e.target.value;

        dispatch(stepperInfoActions.setLocationAccessToApartment(location));
    }

    const handleChangeComment = (e) => {
        const comment = e.target.value;

        dispatch(stepperInfoActions.setComment(comment));
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }, []);

    useEffect(() => {
        if (selectedDate) {
            const combinedDateTime = moment(new Date(selectedDate)).set({
                hour: selectedTime?.split(':')[0],
                minute: selectedTime?.split(':')[1],
            });

            dispatch(stepperInfoActions.setRequestDateTime(combinedDateTime.toISOString()));
        }
    }, [selectedDate, selectedTime, dispatch])

    useEffect(() => {
        const kyivNow = getKyivNow();
        if ((kyivNow.getDate() === new Date(selectedDate).getDate()) && (kyivNow.getMonth() === new Date(selectedDate).getMonth()) && (kyivNow.getFullYear() === new Date(selectedDate).getFullYear())) {
            dispatch(stepperInfoActions.setSelectedTime(filteredTime[0]));
        } else {
            dispatch(stepperInfoActions.setSelectedTime(freeTimeToCome[0]));
        }
    }, [selectedDate]);

    useEffect(() => { 
        if (!selectedTime && filteredTime.length === 0) {
            const currentDate = new Date();
            currentDate.setDate(currentDate.getDate() + 1);
            dispatch(stepperInfoActions.setSelectedDate(currentDate.toISOString()));
            dispatch(stepperInfoActions.setSelectedTime(filteredTime[0] || freeTimeToCome[0]));
            const combinedDateTime = moment(currentDate).set({
                hour: selectedTime?.split(':')[0],
                minute: selectedTime?.split(':')[1],
            });
            dispatch(stepperInfoActions.setRequestDateTime(combinedDateTime.toISOString()));
        }
    }, [selectedTime, filteredTime, dispatch]);


    return (
        <div className={styles.dataTimeOrderPage_wrapper}>
            <div className={styles.dataTimeOrderPage_wrapper_calendar}>
                <p>Оберіть зручну дату <sup>*</sup></p>
                <AppCalendar/>
            </div>

            <FreeTimeToCome filteredTime={filteredTime}/>

            <div className={styles.dataTimeOrderPage_wrapper_getAccessToApartment}>
                <p className={styles.subtitle}>Як ми можемо отримати доступ до вашого будинку? <sup>*</sup></p>

                <div className={styles.dataTimeOrderPage_wrapper_getAccessToApartment_options}>
                    <button
                        onClick={() => handleSelectAccessToApartment('Я буду вдома')}
                        className={`${styles.option} 
                        ${(accessToApartment === 'Я буду вдома') ? styles.selected : ''}`}
                    >Я буду вдома
                    </button>
                    <button
                        onClick={() => handleSelectAccessToApartment('Залишу ключі')}
                        className={`${styles.option} 
                        ${(accessToApartment === 'Залишу ключі') ? styles.selected : ''}`}
                    >Залишу ключі
                    </button>
                    {/*<button*/}
                    {/*    onClick={() => handleSelectAccessToApartment('Я дам код до дверей')}*/}
                    {/*    className={`${styles.option}*/}
                    {/*    ${(accessToApartment === 'Я дам код до дверей') ? styles.selected : ''}`}*/}
                    {/*>Я дам код до дверей*/}
                    {/*</button>*/}
                </div>
            </div>

            {
                ((accessToApartment === 'Я дам код до дверей')
                    || (accessToApartment === 'Залишу ключі')) &&
                <div className={styles.dataTimeOrderPage_wrapper_locationOrCode}>
                    <p className={styles.subtitle}>Якщо ви залишили ключі чи код, напишіть локацію або який
                        код <sup>*</sup>
                    </p>
                    <form action="#">
                        <input
                            value={locationAccessToApartment}
                            onChange={handleChangeLocationAccessToApartment}
                            className={styles.input}
                            type="text"
                            placeholder={'напр. Ключі під ковриком'}
                        />
                    </form>
                </div>
            }
            <div className={styles.dataTimeOrderPage_wrapper_comment}>
                <label>
                    Додаткові коментарі
                    <textarea
                        className={`${styles.input} ${styles.comment}`}
                        name={'comment'}
                        placeholder={'Якщо у вас є додаткові побажання, домофон в квартирі… залиште інформацію тут, щоб клінер міг потрапити до вас'}
                        rows="4"
                        cols="50"
                        onChange={handleChangeComment}
                        defaultValue={comment}
                    />
                </label>
            </div>
        </div>
    );
};

export default DateTimeOrderPage;
